import React, { forwardRef } from 'react';
import { track } from '../modules/tracking';
import PropTypes from 'prop-types';
import { FILTER_VEGGIE, SHOW_DISHES } from '../modules/constants';


/**
 * DietFilter - child filter component which allows filtering of the results on the page by dietary requirements.
 *
 * @function
 * @param    {object} props the properties for this filter.
 * @param    {object} ref   Ref forwarded from the parent filter component.
 * @returns  {HTMLElement}       Form allowing choosing of allergens to filter out.
 * @constructor
 */
const DietFilter = forwardRef(function DietFilterRef(props, ref) {
    const { dietFilter, setDietFilter } = props;

    function collectDietFilterData(e) {
        const checkboxes = ref.current.querySelectorAll('[type="checkbox"]');
        const newfilter = [];
        [].forEach.call(checkboxes, (checkbox) => {
            if (checkbox.checked) {
                newfilter.push(checkbox.name.toUpperCase());
            }
            track(
                `Filters: Click: Dietary requirements: ${checkbox.name} ${checkbox.checked ? 'filter on' : 'filter off'
                }`
            )();
        });
        setDietFilter(newfilter.sort());
    }

    return (
        <div className={props.blockClass}>
            <p>{SHOW_DISHES}</p>
            <form ref={ref} onChange={collectDietFilterData.bind(this)}>
                <input
                    id='vegetarian'
                    name='vegetarian'
                    type='checkbox'
                    value='vegetarian'
                    defaultChecked={dietFilter.indexOf('VEGETARIAN') !== -1}
                />
                <label className='veggie' htmlFor='vegetarian'>
                    {FILTER_VEGGIE}
                </label>
            </form>
        </div>
    );
});

DietFilter.propTypes = {
    dietFilter: PropTypes.array,
    setDietFilter: PropTypes.func,
    setShowFilter: PropTypes.func,
    showFilter: PropTypes.bool,
    blockClass: PropTypes.string
};

export { DietFilter };
